import React, { useState } from 'react';

// Set-password landing for admins. Used for both initial admin invites and
// "forgot password" resets -- backend POST /api/auth/accept-invite/:token
// accepts any non-expired token attached to a role='admin' user and sets the
// password. On success we land them logged in at /.
//
// Mirrors ParentSetPassword but: hits the admin endpoint, stores the admin
// token under 'ngs_token', and redirects to / instead of /parent.
export default function AdminSetPassword({ token }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [done, setDone]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`/api/auth/accept-invite/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Something went wrong.'); return; }
      localStorage.setItem('ngs_token', data.token);
      setDone(true);
      setTimeout(() => { window.location.href = '/'; }, 1500);
    } catch {
      setError('Network error — please try again.');
    } finally {
      setLoading(false);
    }
  };

  const page = {
    minHeight: '100vh', background: '#0d0d0d',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
  };
  const card = {
    background: '#1a1a1a', border: '1px solid #2e2e2e',
    borderRadius: 12, padding: 32, width: '100%', maxWidth: 420,
    boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
  };
  const label = {
    fontSize: '0.72rem', color: '#aaa', fontWeight: 700,
    textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6, display: 'block',
  };
  const input = {
    background: '#242424', border: '1px solid #2e2e2e', borderRadius: 8,
    padding: '11px 14px', color: '#fff', fontSize: '0.92rem', width: '100%',
  };
  const submit = {
    background: '#C04A0E', color: '#fff',
    fontFamily: 'Barlow Condensed, sans-serif',
    fontSize: '1rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em',
    padding: 13, borderRadius: 8, border: 'none', cursor: 'pointer', width: '100%', marginTop: 8,
  };
  const errStyle = {
    background: 'rgba(231,76,60,0.12)', color: '#e74c3c',
    padding: '10px 12px', borderRadius: 6, fontSize: '0.85rem', marginBottom: 12,
  };

  return (
    <div style={page}>
      <div style={card}>
        {done ? (
          <div style={{ textAlign: 'center', color: '#fff' }}>
            <div style={{ fontSize: 36, color: '#2ecc71', marginBottom: 12 }}>✓</div>
            <div style={{ fontSize: '0.95rem' }}>Password set — redirecting to your portal...</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <h2 style={{
              color: '#fff', fontSize: '1.3rem', fontWeight: 800,
              fontFamily: 'Barlow Condensed, sans-serif', textTransform: 'uppercase',
              letterSpacing: '0.04em', marginBottom: 8,
            }}>Set Your Password</h2>
            <p style={{ color: '#aaa', fontSize: '0.86rem', marginBottom: 20, lineHeight: 1.5 }}>
              Pick a password for your NGS Admin Portal account. You'll use your email and this password to sign in.
            </p>
            {error && <div style={errStyle}>{error}</div>}
            <div style={{ marginBottom: 14 }}>
              <label style={label}>New Password</label>
              <input style={input} type="password" placeholder="Minimum 8 characters"
                value={password} onChange={e => setPassword(e.target.value)} disabled={loading} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={label}>Confirm Password</label>
              <input style={input} type="password" placeholder="Re-enter password"
                value={confirm} onChange={e => setConfirm(e.target.value)} disabled={loading} />
            </div>
            <button type="submit" style={{ ...submit, opacity: (loading || !password || !confirm) ? 0.5 : 1 }}
              disabled={loading || !password || !confirm}>
              {loading ? 'Setting up...' : 'Set Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
